/**
* Determines if a popper is currently visible
* @param {Element} popper
* @return {Boolean}
*/
export default function isVisible(popper) {
  return popper.style.visibility === 'visible'
}



// WEBPACK FOOTER //
// ./src/Tooltip/js/utils/isVisible.js


// WEBPACK FOOTER //
// webpack:///src/Tooltip/js/utils/isVisible.js